import { format } from 'date-fns'
import { PayTypeEnum } from 'types/enum'
import { isLogined } from 'service/sign'
import { RouterPaths } from './constant'
import ModelFn from 'components/model/ModelFn'
import { getshoplink } from "service/shop"

interface Validate {
  value: any
  hint: string
}
export function checkCaptcha() {
  const captchaType = window['captcha_type']
  
  if (captchaType && captchaType !== 'aliyun-nvc' && !window['captcha']) {
    return true
  }
  return false
}

export function getCaptcha() {
  const captchaType = window['captcha_type']

  if (captchaType) {
    return captchaType === 'aliyun-nvc' ? window['getNVCVal']() : window['captcha']
  }

  return null
}
export function resetVerify(setreset){
  const captchaType = window['captcha_type']
  if (captchaType && captchaType !== 'aliyun-nvc' && window['captcha']) {
    setreset(true)
    setTimeout(() => {
      setreset(false)
    }, 10)
    window['captcha'] = ''
  }
}

export function isWidthMobile(): boolean {
  return window.matchMedia('(max-width: 767px)').matches
}

export function formsValidate(fn, args: Validate[]) {
  for (const v of args) {
    if (!fn(v.value)) {
      return [false, v.hint]
    }
  }
  return [true, null]
}

export function notEmptyValidate(args: Validate[]) {
  const fn = (value) => {
    return value != null && value !== ''
  }
  return formsValidate(fn, args)
}

export function isMobileChorme() {
  const ua = window.navigator.userAgent.toLowerCase()
  if (ua.includes('android') && ua.includes('chrome')) {
    return true
  }
  return false
}

export function isMobile(){
  const ua = navigator.userAgent.toLowerCase()
  const agents = ["android", "iphone", "symbianos", "windows phone", "ipod", "ipad",'Phone']
  for(let i = 0; i < agents.length; i++){
    if(ua.includes(agents[i])) return true
  }
  return false
}

export function toNumber(value: any, defaultNumber?: number): number {
  defaultNumber = defaultNumber || 0
  const num = Number(value)
  if (value == null) {
    return defaultNumber
  }
  if (isNaN(num)) {
    return defaultNumber
  }
  return num
}

export function openUrl(url: string, blank = true) {
  window.open(url, blank ? '_blank' : undefined)
}

export function getSearch(key: string): string | undefined {
  const search = window.location.search.slice(1)
  if (search) {
    const searchObj = {}
    search.split("&").forEach(s => {
      const key = s.split("=")[0]
      const value = s.split("=")[1]
      searchObj[key] = value
    })

    return searchObj[key]
  }
}

export function timeRemain (time: number) {
  const ms = time * 1000 - Date.now()
  const day = Math.ceil(ms / 1000 / 60 / 60 / 24)

  if (day >= 1) {
    return `${day-1}天`
  } else if (day > 0) {
    const h = Math.floor(ms / 1000 / 60 / 60)
    const m = Math.floor(ms / 1000 / 60)
    return `${h}小时${m}分钟`
  } else {
    return `0天`
  }
}

export function getNowString() {
  const now = new Date()
  const y = now.getFullYear()
  const M = now.getMonth() + 1
  const d = now.getDate()
  const h = now.getHours()

  return `${y}${M}${d}${h}`
}

export function showMoney(n: any) {
  const r = (n / 100).toFixed(2)
  return `¥${r}`
}

export function defaultDateFormat(t: any) {
  const tep = 'yyyy.MM.dd HH:mm:ss'
  return format(t * 1000, tep)
}

export function payTypeToCurrencySymbol(t: string) {
  switch (t) {
  case PayTypeEnum.paypal:
    return "$"
  case PayTypeEnum.alipay_qr_intl:
    return "HK$"
  default:
    return "¥"
  }
}
//去除首尾空格
export function trim(string) {
  if(string.trim) {
    return string.trim()
  }else {
    const reg = /^\s+|\s+$/g
    return string.replace(reg,"")
  }
}


export const toShop = async (type) => {
  if(!isLogined()){
    ModelFn.confirm({
      text: "请先登录穿梭账号",
      onConfirm: () => { isMobile() ? window.location.replace(`${RouterPaths["signin-phone"]}?redirect=${RouterPaths['shop']}&type=${type}`) : window.location.replace(`${RouterPaths["signin-qr"]}?redirect=${RouterPaths['shop']}&type=${type}`) },
      noCancel: true
    })
  }else { 
    const res = await getshoplink()
    if(res.code === 0) {
      window.location.replace(res.links[type])
    }
  }

  
  
}
